module.exports = __webpack_public_path__ + "img/1.1f86984f.png";